import {Children, useCallback, useEffect, useState} from 'react'
import styled      from 'styled-components'
import HtmlContent from '../../components/general/misc/HtmlContent';

import MenuTitle from '../../components/general/misc/MenuTitle'
import {getCustomersService, getCustomersPageTitle} from '../../services/pagesRequestServices'

const Customers = () => {
  const [customersData, changeCustomersData] = useState([])
  const [pageTitle, changePageTitle] = useState(null)

  const getCustomersData = useCallback(() => {
    return getCustomersService()
      .then(({ results }) => changeCustomersData(results))
  }, [])

  const getPageTitle = useCallback(() => {
    return getCustomersPageTitle()
      .then((res) => changePageTitle(res))
  }, [])

  useEffect(() => {
    getCustomersData()
    getPageTitle()
  }, [getCustomersData, getPageTitle])

  return <div className="row subpage__container">
    <div className="col-12 px-0 px-md-2">
      <p className="text-14 text-md-18 line-height-2x px-3 px-md-0 mt-3 text-white">
        {pageTitle?.title}
      </p>
    </div>
    <div className="col-12 px-0 px-md-2">
      <CustomerList className="d-flex flex-wrap justify-content-center">
        {Children.toArray(
          customersData.map(item =>
            <CustomerBox>
              <div className={'border border-blue rounded p-2 p-md-3'}>
                <ContentContainer>
                  <StyledImageLogo
                    href={item.url} target="_blank" rel="noreferrer"
                    className="d-flex align-items-center bg-white rounded p-1 p-md-2 overflow-hidden me-3"
                    >
                    <img src={item.logo} alt={item.title} className="w-100"/>
                  </StyledImageLogo>
                  <a className="d-inline-block"
                      href={item.url} target="_blank" rel="noreferrer">
                    <MenuTitle text={item.title}/>
                  </a>
                  {item.abs_description &&
                    <div className="text-white text-14 font-weight-300">
                      <HtmlContent rawHtml={item.abs_description} />
                    </div>
                  }
                </ContentContainer>
                {item.success_story_page_url &&
                  <a href={item.success_story_page_url} className="d-block text-12 line-height-2x mt-3 text-green">بیشتر بدانید</a>
                }
              </div>
            </CustomerBox>
          )
        )}
      </CustomerList>
    </div>
  </div>
}

export default Customers

const CustomerList = styled.div`
  margin: -0.5rem;
`

const CustomerBox = styled.div`
  width: 400px;
  margin: 0.5rem;
`

const ContentContainer = styled.div`
  min-height: 100px;
  max-height: 192px;
  overflow: hidden;
`

const StyledImageLogo = styled.a`
  width: 100px;
  height: 100px;
  float: left;
`
